import moment from 'moment';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Desktop, Mobile } from '../../App';
import { useAppSelector } from '../../app/hooks';
import { AnimatedDashboard } from '../../components/animation/AnimatedDashboard';
import { AnimatedItem } from '../../components/animation/AnimatedItem';
import { SidebarModal } from '../../components/common/Sidebar/Sidebar';
import Spinner from '../../components/common/Spinner';
import {
  CLUB,
  LP,
  MIX,
  USDC,
  USDT,
  formatUSD,
  formatUSDNoDecimals
} from '../../helpers/helperFunctions';
import { getOrders } from '../../slices/orders-slice';
import { Flexed, PageTitle } from '../../styles/GlobalComponents';
import { FlexBetween, HubLengthMessage } from '../../styles/stylesStyled';
import { CurrencyType } from '../../types/types';
import {
  InvoiceHeader,
  Invoices,
  InvoicesMobile
} from '../Accounting/AccountingStyled';
import { MyOrderListModel, OrderItem } from '../Marketplace/Maeketplace.types';
import { Link } from 'react-router-dom';
import { ORDER_INVOICES, ORDER_ITEMS } from '../../routes/routes';
import { Button } from '../../components';
import WaitingForPaymentPackage from './WaitingForPaymentPackage';

export enum OrderType {
  ORDER = 1,
  PACKAGE,
  LICENCE,
  COMBO,
  EVENT_TICKET,
  DISCOUNT_CODE,
  TRAVEL_SUBSCRIPTION
}

export const Orders = () => {
  const [isOrderModalOpen, setIsOrderModalOpen] = useState(false);

  const [selectedOrder, setSelectedOrder] = useState<any>();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getOrders());
  }, [dispatch]);

  const { loading, orders } = useAppSelector((state) => state.orders);

  if (loading && !orders) {
    return <Spinner fullScreen />;
  }

  return (
    <AnimatedDashboard zoom>
      <PageTitle> Orders</PageTitle>
      <Desktop>
        <InvoiceHeader>
          <div style={{ width: '10%' }}>Order ID</div>
          <div style={{ width: '15%' }}>Order Number</div>
          <div style={{ width: '10%' }}>Price</div>
          <div style={{ width: '12.5%' }}>Date Created</div>
          <div style={{ width: '12.5%' }}>Date Paid</div>
          <div style={{ width: '12.5%' }}>Order Items</div>
          <div style={{ width: '12.5%' }}>Invoices</div>
          <div style={{ width: '12.5%' }}>Status</div>
          <div style={{ width: '15%' }}></div>
        </InvoiceHeader>
      </Desktop>
      {orders?.length === 0 ? (
        <HubLengthMessage>No orders</HubLengthMessage>
      ) : (
        orders?.map((inv: MyOrderListModel, i: number) => {
          return (
            <AnimatedItem key={i} index={i}>
              <Invoices>
                <div style={{ width: '10%' }}>{inv.id}</div>
                <div style={{ width: '15%' }}>{inv.orderNumber}</div>
                <div style={{ width: '10%' }}>
                  {formatUSDNoDecimals(inv.totalPrice)}
                </div>
                <div style={{ width: '12.5%' }}>
                  {moment.utc(inv?.dateCreated).format('DD/MM/YY')}
                </div>
                <div style={{ width: '12.5%' }}>
                  {inv?.datePaid &&
                    moment.utc(inv?.datePaid).format('DD/MM/YY')}
                </div>

                <div style={{ width: '12.5%' }}>
                  <Link to={`${ORDER_ITEMS}/${inv.id}`}>
                    {inv?.orderItems?.length}
                  </Link>
                </div>
                <div style={{ width: '12.5%' }}>
                  <Link to={`${ORDER_INVOICES}/${inv.id}`}>
                    {inv?.invoices?.length}
                  </Link>
                </div>
                <div
                  style={{
                    width: '12.5%'
                  }}>
                  {inv.status}
                </div>

                <div
                  style={{
                    width: '15%'
                  }}>
                  {inv?.status !== 'paid' && (
                    <Button
                      onClick={() => {
                        setIsOrderModalOpen(!isOrderModalOpen);
                        setSelectedOrder(inv);
                      }}>
                      Proceed to payment
                    </Button>
                  )}
                </div>
              </Invoices>
            </AnimatedItem>
          );
        })
      )}

      <SidebarModal
        isOpen={isOrderModalOpen}
        setOpen={setIsOrderModalOpen}
        title={'Payment Instructions'}
        sidebarWidth={'650px'}>
        <WaitingForPaymentPackage
          totalPrice={selectedOrder?.totalPrice}
          invoices={selectedOrder?.invoices}
        />
      </SidebarModal>

      {/* <SidebarModal
        isOpen={isSideModalOpen}
        setOpen={setIsSideModalOpen}
        title={t('my_hubs_part.payment_instructions_title')}
        sidebarWidth={'511px'}>
        <WaitingForPaymentPackage selectedPackage={selectedPackage} />
      </SidebarModal>

      <SidebarModal
        isOpen={isCancelModalOpen}
        setOpen={setIsCancelModalOpen}
        title={t('my_hubs_part.cancel_order_title')}
        sidebarWidth={'511px'}>
        <CancelPaymentPackage
          setIsCancelModalOpen={setIsCancelModalOpen}
          selectedPackage={selectedPackage}
        />
      </SidebarModal> */}
    </AnimatedDashboard>
  );
};
